// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"be5795d0","container":"f35a55ad","clickable":"dd4bfdd3","editButton":"d53b1847","inputContainer":"dbd0e0a7"};